<app-confetti></app-confetti>
<mine-snackbar class="snackbar"></mine-snackbar>

<main class="main">
    <router-outlet></router-outlet>
</main>